import { useEffect } from "react";

export const useOnce = function (f: () => void | Promise<void>): void {
  useEffect(() => {
    f();
  }, []); // only run once
};
